import sanitize from 'sanitize-html';
import styles from './TextBlock.module.scss';
import classNames from 'classnames';

export const Cypress_Data = {
  textBlock: 'base-text-block',
};

export type textBlockType = 'info' | 'warning' | 'error';

interface Props {
  text: string;
  type: textBlockType;
  dataCy?: string;
}

const TextBlock = ({ text, type, dataCy }: Props) => {
  return (
    <div
      data-cy={dataCy || Cypress_Data.textBlock}
      data-layout-role="text-block"
      className={classNames(styles.wrapper, {
        [styles.info]: type === 'info',
        [styles.warning]: type === 'warning',
        [styles.error]: type === 'error',
      })}
      dangerouslySetInnerHTML={{ __html: sanitize(text) }}
    />
  );
};

export default TextBlock;
